import axios from "axios";
import { Buffer } from "buffer";
import dayjs from "dayjs";
import { doc, setDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { FiChevronLeft } from "react-icons/fi";
import { RecoilRoot, useRecoilState } from "recoil";
import { SWRConfig } from "swr";
import './App.css';
import AuthenticateUser from "./app/Authenticate";

import AppLayout from "./app/Layout";
import Nav from "./app/Nav";
import OrderCard from "./app/OrderCard";
import OrderPreview from "./app/OrderPreview";
import "./app/pc.css";
import POS, { POSCart } from "./app/POS";
import StockList, { StockItem } from "./app/Stock";
import { currectOrderAtom } from "./config/atoms";
import { db } from "./config/firebase";
import audio from "./hooks/on_notification.mp3";
import useIncoming from "./hooks/useIncoming";
import useOrders from "./hooks/useOrders";
import useServices from "./hooks/useServices";
import useStatus from "./hooks/useStatus";
import useUser from "./hooks/useUser";

const dev = false

function CurApp() {

    const [width, setWidth] = useState(window.innerWidth)

    useEffect(() => {

        window.addEventListener("resize", (e) => {
            setWidth(window.innerWidth)
        })

    }, [])

    //auth
    const { user, userLoading, signUserIn } = useUser()
    const { services } = useServices()

    //app navigation
    const [nav, setNav] = useState("orders")

    //bluetooth
    const [available, setAvailable] = useState(false)
    const [loading, setLoading] = useState(true)
    const [pairedDevice, setPairedDevice]  = useState(null)

    //incoming orders 
    const orders = useOrders()
    const incoming = useIncoming()
    const [currentOrder, setCurOrder] = useRecoilState(currectOrderAtom)
    const [showOrder, setShowOrder] = useState(null)

    useEffect(() => {

        if(!currentOrder) {
            if(orders[0]) {
                setCurOrder(orders[0])
            }
        }

    }, [orders])

    //status
    const { session, closeAllOrders, ToggleOnline } = useStatus(setLoading)


    useEffect(() => { 
 
        if(navigator.bluetooth) {

            navigator.bluetooth.getAvailability().then((av) => {
                setAvailable(av)
                setLoading(false)
            }) 
        }

    }, [])


    async function getTemplate(order, checkout) {

        let url = false ? "http://localhost:5000/bindoo-pos/us-central1/receipt" : "https://us-central1-bindoo-pos.cloudfunctions.net/receipt";

        const curOrder = order

        const {data} = await axios.post(url + (checkout ? "/checkout" : ""), {
            ...curOrder,
            formatedDate: dayjs(curOrder?.date).format("DD/MM/YY HH:mm")
        })

        return [ "", "", ...data.split("\n"), "", "", ""]
    }

    async function onCloseOrders() {

        closeAllOrders(orders)

    }

    async function onPrintReceipt(order) {

        setLoading(true)
        
 
        try {

            const arr = await getTemplate(order)

            for await (const str of arr) {
                
                await pairedDevice.writeValue(Buffer.from(str + "\n", 'utf-8'));
    
            }

            const status = "orderready"

            await setDoc(doc(db, `orders/${order?.id}`), {
                status,
                data: {
                    ...order.data,
                    status
                }
            }, { merge: true })

            setLoading(false)
            window.alert("Order In Prep")
            
        
        } catch(err) {
            console.log("printer: ", err)
            console.log(err)
            setLoading(false)
            if(err.message.indexOf("GATT") > -1) {
                alert("Printer Error: Please check papers and or try switching off then on and reconnect device.")
            } else {
                alert("An error occured: " + err.message)
            }
        }
        

    }

    async function connectPrinter() {

        setLoading(true)
         
        const device = await navigator.bluetooth.requestDevice({ 
            filters: [{
                name: "BlueTooth Printer" 
            }], 
            optionalServices: ['000018f0-0000-1000-8000-00805f9b34fb'],
        })
        
        const connection = await device.gatt.connect();
        const service = await connection.getPrimaryService('000018f0-0000-1000-8000-00805f9b34fb')
        const characteristic = await service.getCharacteristic('00002af1-0000-1000-8000-00805f9b34fb')
       
        setPairedDevice(characteristic)
        setLoading(false)
        window.alert("paired")

    }

    if(userLoading) {
        return (
            <div className="backsplash">
                <p style={{ color: "#FFF"}}>Loging In...</p>
            </div>
        )
    }
   
    if(!available) {
        return (
            <div className="backsplash">
                <p style={{ color: "#FFF"}}>Bluetooth is not available on this browser, try using chrome or safari</p>
            </div>
        )
    }

    if(!user) {
        return <AuthenticateUser
            signUserIn={signUserIn}
        />
    }

    return (
        <>
            <AppLayout 
                width={width}
                nav={
                    <Nav 
                        active={nav} 
                        update={setNav}
                        width={width}
                    />} 
                current={
                    nav === "stock" ? <></> :
                    nav === "pos" ? 
                    <POSCart
                        width={width}
                        setLoading={setLoading}
                        printOrder={onPrintReceipt}
                        setCurOrder={setCurOrder}
                        pairedDevice={pairedDevice}
                        getTemplate={getTemplate}
                    />
                    :
                    <OrderPreview 
                        connectDevice={connectPrinter}
                        printOrder={() => onPrintReceipt(currentOrder)}
                        printer={pairedDevice}
                        setLoading={setLoading}
                        curValue={session?.total_items}
                    />
                }
            >
                {nav === "stock" ? <StockList width={width} setLoading={setLoading} services={services} /> :
                nav === "pos" ? <POS services={services}  setLoading={setLoading} width={width} /> :
                (
                    <>
                        <div id="balances-header">
                            <div>
                                <h3>Balance: R{((session?.total_items || 0) * 2).toFixed(2)}</h3>
                                <p
                                    style={{
                                        color: user?.storeOnline ? "var(--successColor)" : "var(--errorColor)"
                                    }}
                                >Status: {user?.storeOnline ? "Online" : "Offline"}</p>
                            </div>
                            <div id="balances-buttons">
                                <button onClick={onCloseOrders}>Close Orders</button>
                                <button 
                                    style={{
                                        backgroundColor: user?.storeOnline ? "var(--successColor)" : "var(--errorColor)"
                                    }}
                                    onClick={() => ToggleOnline()}>Go {user?.storeOnline ? "Offline" : "Online"}</button>
                            </div>
                        </div>
                        <div style={{ width: width < 768 ? '98%' :  '80%', margin: '0 auto'}}>
                            {orders.map(item => (
                                <OrderCard key={"item-" + item?.id} width={width} item={item} showOrder={setShowOrder} />
                            ))}
                        </div>
                        {orders?.length === 0 && <p
                            style={{
                                textAlign: "center",
                                margin: 20
                            }}
                        >There are no orders</p>}
                    </>
                )}
            </AppLayout>
            {false && (
                <div className="backsplash">
                    <StockItem width={width} /> 
                </div>
            )}
            {incoming && nav !== "orders" && (
                <NotificationDisplay
                    title="New Order"
                    message="There is a new order waiting to be accepted"
                />
            )}
            {(incoming && nav === "orders") && <div className="backsplash">
                <div style={{ 
                    width: width < 600 ? '95vw' : (width < 768 && width >= 600) ? '60vw' : '30vw' 
                }}>
                    <OrderPreview 
                        connectDevice={connectPrinter}
                        printOrder={onPrintReceipt} 
                        incoming={incoming}
                        printer={pairedDevice}
                        setLoading={setLoading}
                        curValue={session?.total_items}
                    />
                </div>
            </div>}
            {(showOrder && width < 768) && <div className="backsplash">
                <div style={{ 
                    width: width < 600 ? '95vw' : (width < 768 && width >= 600) ? '60vw' : '30vw' 
                }}>
                    <OrderPreview 
                        connectDevice={connectPrinter}
                        printOrder={onPrintReceipt} 
                        incoming={incoming}
                        order={orders.find(item => item.id === showOrder)}
                        printer={pairedDevice}
                        setLoading={setLoading}
                        curValue={session?.total_items}
                    />
                </div>
                <div className="back-button" onClick={() => setShowOrder(null)}>
                    <FiChevronLeft size={27} color="var(--text)" />
                    <p>Go Back</p>
                </div>
            </div>}
            <audio hidden src={audio} id="alert-audio" /> 
            {loading && (
                 <div className="backsplash">
                    <p style={{ color: "#FFF"}}>Please Wait...</p>
                 </div>
            )}
        </>
    )
};

function NotificationDisplay({ title, message }) {
    return (
        <div className="notify-wrapper">
            <h3>{title}</h3>
            <p>{message}</p>
        </div>
    )
}


export default function App() {
    return (
        <SWRConfig>
            <RecoilRoot>
                <CurApp />
            </RecoilRoot>
        </SWRConfig>
    )
}